module.exports = __webpack_public_path__ + "img/fistBump.014acaa0.gif";